import { axiosInstance } from "./config"

export const getAllUsers = async()=>{
    const response = await axiosInstance.get('/users')
    return response.data
}
export const createUser = async(data)=>{
    const resposnse = await axiosInstance.post('/users',data)
    return resposnse.data
}
 
export const getUser = async(id)=>{
    const resposnse = await axiosInstance.get(`/users${id}`)
    return resposnse.data
}
export const updateUser = async(id,data)=>{
    const resposnse = await axiosInstance.put(`/users${id}`,data)
    return resposnse.data
}
export const deleteUser = async(id)=>{
    const resposnse = await axiosInstance.delete(`/users${id}`)
    return resposnse.data
}